module.exports = __webpack_public_path__ + "assets/f29c812dccb9db7ab84f69be9002c7a2.mp3";